import request from "../utils/request";

export const list = (data) => request.get("/api/payment", data);
export const pay = (data) => request.post("/api/payment/paid", data);
export const transfer = (id) => request.post(`/api/payment/transfer/${id}`);
export const cancel = (data) => request.post("/api/payment/cancel", data);